import Vuex from "vuex";
import project from "./modules/project_modules";
import user from "./modules/user";
import messageInfo from './modules/message.js';
import blueTooth from './modules/bluetooth.js';
import createPersistedState from "vuex-persistedstate";

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            // storage: window.localStorage, // 使用sessionStorage存储state
            reducer(data) {
                return {
                    user: data.user,
                    project: data.project,
                };
            }
        })
    ],
    state: {
        navindex: 0,
        barHeight: 0 //状态栏高度
    },
    mutations: {},
    actions: {},
    modules: {
        project,
        user,
        messageInfo,
        blueTooth
    }
});
